(function () {
  function initMagnetic(scope) {
    if (typeof TweenMax === 'undefined') return;
    var root = scope || document;
    var links = [].slice.call(root.querySelectorAll('[data-magnetic]'));

    links.forEach(function (link) {
      var span = link.querySelector('span');
      if (!span) {
        span = document.createElement('span');
        span.textContent = link.textContent;
        link.textContent = '';
        link.appendChild(span);
      }
      var force = parseFloat(link.getAttribute('data-magnetic-force')) || 20;

      function onMove(e) {
        var r = link.getBoundingClientRect();
        var relX = e.clientX - r.left;
        var relY = e.clientY - r.top;
        TweenMax.to(span, 0.3, {
          x: ((relX - r.width / 2) / r.width) * force,
          y: ((relY - r.height / 2) / r.height) * force,
          ease: Power2.easeOut
        });
      }
      function onLeave() {
        TweenMax.to(span, 0.3, { x: 0, y: 0, ease: Power2.easeOut });
      }

      link.addEventListener('mousemove', onMove);
      link.addEventListener('mouseleave', onLeave);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initMagnetic(document); });
  document.addEventListener('shopify:section:load', function (e) { initMagnetic(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initMagnetic(e.target); });
})();
